import React, { useState, useEffect } from "react";
import { Typography } from "@material-ui/core";
import { API_SERVICE_MAP } from "../../constants";
import { useTranslation } from "react-i18next";

const LocationServicesList = ({
  servicesAvailable = [],
  customFilter = () => true
}) => {
  const { t } = useTranslation();
  const [services, setServices] = useState([]);

  useEffect(() => {
    if (!servicesAvailable) return;

    setServices(
      servicesAvailable
        .filter(customFilter)
        .filter(service => API_SERVICE_MAP[service.service_code])
    );
  }, [servicesAvailable]);

  if (services.length <= 0) return null;

  return (
    <Typography align="center">
      <strong>{t("components.location_services_list.title")}:</strong>{" "}
      {services.map((service, index) => (
        <Typography component="span" key={`service-${service.service_code}`}>
          {API_SERVICE_MAP[service.service_code].label}
          {index + 1 < services.length && ", "}
        </Typography>
      ))}
    </Typography>
  );
};

export { LocationServicesList };
